import { Injectable } from '@angular/core';
import { EduContent } from '@campus/dal';
import { ContentActionInterface } from '../..';
import { ContentTaskActionsServiceInterface } from './content-task-actions.service.interface';

@Injectable({
  providedIn: 'root',
})
export class ContentTaskActionsDefaultService implements ContentTaskActionsServiceInterface {
  public getTaskActionsForEduContent(eduContent: EduContent, inTask: boolean): ContentActionInterface[] {
    return [];
  }
}
